<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'ميزانية البرنامج'" :to="{name: 'budgets'}"> ميزانية البرنامج</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        إدارة ميزانية البرنامج
                                        </h4>
                                    </div>
                                     <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item"><create-button  v-if="hasPermissions('budgets_create')" :routeName="'budgets.create'"></create-button></li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>

                                      </div>

                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                          <v-select v-model="stage" :options="stages" @search="onSearchStage" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.program_date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.program_date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طبع
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{index+1}}</td>
                                                    <td>{{item.program_date}}</td>
                                                    <td>
                                                      <label v-for="(st, k) in item.stages" :key="k" class="badge badge-success">{{st.name}}</label>
                                                      
                                                    </td>
                                                    <td class="text-center">

                                                        <div class="dropdown custom-dropdown">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>

                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                                <edit-button v-if="item.status == 0 && hasPermissions('budgets_edit')" :routing="{name: 'budgets.edit', params: {id: item.id}}"></edit-button>

                                                                <delete-button v-if="hasPermissions('budgets_delete')" :deleteUrl="'/budgets/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                  <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>

                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
              <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                   <table class="table table-bordered">
                    <tbody>
                      <tr class="text-center">
                        <th colspan="4">
                          الميزانية<br>
                        </th>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td colspan="2">التاريخ</td>
                        <td colspan="2">{{printData.program_date}}</td>
                      </tr>
                      <tr>
                        <td>المسئول </td>
                        <td>{{printData.teacher ? printData.teacher.name : '---'}}</td>
                        <td>المراحل الدراسية</td>
                        <td v-if="printData.stages">
                          <label class="label label-success" v-for="(st, k) in printData.stages" :key="k"> {{ k ? ', ' : ''  }} {{ st.name }}</label>
                        </td>
                      </tr>
                      <tr>
                        <td>المدة</td>
                        <td>{{printData.period}}</td>
                        <td>المكان</td>
                        <td>{{printData.place}}</td>
                      </tr>
                      <tr>
                        <td colspan="2">الوصف</td>
                        <td colspan="2">{{printData.description}}</td>
                      </tr>

                      <tr>
                        <td>عدد طلاب المرحلة</td>
                        <td>{{printData.student_stage_no}}</td>
                        <td>عدد الحضور المتوقع</td>
                        <td>{{printData.attend_no}}</td>
                      </tr>

                      <tr>
                        <td>رسوم الاشتراك</td>
                        <td>{{printData.fees}}</td>
                        <td>إجمالى الاشتراكات</td>
                        <td>{{printData.total_fees}}</td>
                      </tr>

                      <tr>
                        <td>إجمالى التكلفة التقليدية</td>
                        <td>{{printData.total_cost}}</td>
                        <td>العجز المتوقع</td>
                        <td>{{printData.expect_cost}}</td>
                      </tr>

                    </tbody>
                  </table>
                   <table class="table table-bordered">
                    <thead>
                      <tr class="text-center">
                        <th colspan="3">تكلفة البرنامج التقديرية</th>
                      </tr>
                      <tr>
                        <th>البند</th>
                        <th>التكلفة التقديرية</th>
                        <th>الوصف</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(v, k) in printData.items" :key="k">
                        <td>{{v.name}}</td>
                        <td>{{v.pivot.item_cost}}</td>
                        <td>{{v.pivot.item_description}}</td>
                      </tr>
                    </tbody>
                   </table>
                </div>
              </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      printData: {
      },
      data: {
        data: {},
        searching:{
            id: '',
            stage_id: '',
            parent_mobile: '',
            program_date_from: '',
            program_date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.flashAlert();
      this.search(null, '', this, 'stage');
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'مزانية البرنامج');
      }, 1000);
    },
    print(data){
      this.printData = data;
        this.$baseApi.get('/budgets/' + data.id).then((response)=>{
            if(response.data.code == 200){
              this.printData = response.data.data.budget;
              setTimeout(() => {
                this.print_element('printMe', 'ميزانية');


              }, 2000);

            }else{
                alert(response.data.error.error);
            }
        });
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/budgets?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
          if(loading){
            loading(false);
          }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/budgets?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.budgets;
               this.data.data = response.data.data.budgets.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    }
  }
};
</script>
<style>
</style>
